/**
 * Route for `custom-login-domain`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CustomLoginDomainPage } from "../features/custom-login-domain/CustomLoginDomainPage";

export const customLoginDomainRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/custom-login-domain",
	component: CustomLoginDomainPage,
});

export default customLoginDomainRoute;
